const cards = [
  {
    image: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20webtoon%20scene%20illustration%2C%20two%20characters%20in%20school%20uniform%20under%20cherry%20blossom%20tree%2C%20warm%20spring%20atmosphere%2C%20soft%20pastel%20tones%2C%20clean%20minimal%20background%2C%20modern%20webtoon%20art%20style&width=800&height=500&seq=card-manga-01&orientation=landscape',
    tag: '韩漫推荐',
    tagColor: 'bg-accent-100 text-accent-700',
    title: '2024韩漫年度盘点：十部必看神作',
    desc: '从《秘密教学》到《女神降临》，盘点今年最值得追的韩漫作品，每一部都是口碑与人气双丰收。',
    time: '3天前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Japanese%20shonen%20manga%20action%20scene%20illustration%2C%20epic%20battle%20with%20energy%20effects%2C%20dark%20fantasy%20world%2C%20warm%20amber%20lighting%2C%20clean%20minimal%20background%2C%20modern%20anime%20art%20style&width=800&height=500&seq=card-manga-02&orientation=landscape',
    tag: '日漫追更',
    tagColor: 'bg-primary-100 text-primary-700',
    title: '咒术回战最终章：结局走向深度分析',
    desc: '涩谷事变后的剧情走向引发全网热议，五条悟的命运牵动无数读者的心，结局到底会如何发展？',
    time: '1天前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20martial%20arts%20scene%20illustration%2C%20warrior%20cultivating%20in%20ancient%20Chinese%20palace%2C%20golden%20light%20aura%2C%20epic%20atmosphere%2C%20clean%20minimal%20background%2C%20modern%20Chinese%20comic%20style&width=800&height=500&seq=card-manga-03&orientation=landscape',
    tag: '国漫精选',
    tagColor: 'bg-secondary-100 text-secondary-700',
    title: '国漫崛起进行时：五部品质不输日漫的佳作',
    desc: '从作画到剧情全面升级，这些国漫作品正在用实力证明中国漫画的未来值得期待。',
    time: '5天前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20scene%20illustration%2C%20mysterious%20dark%20alley%20with%20suspenseful%20atmosphere%2C%20noir%20style%2C%20warm%20amber%20streetlight%2C%20clean%20composition%2C%20modern%20webtoon%20art%20style&width=800&height=500&seq=card-manga-04&orientation=landscape',
    tag: '编辑精选',
    tagColor: 'bg-accent-100 text-accent-700',
    title: '冷门佳作挖掘：那些被低估的高分漫画',
    desc: '排行榜之外同样有好作品，我们为你整理了一份冷门但质量极高的漫画推荐清单。',
    time: '2天前',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Japanese%20slice%20of%20life%20manga%20scene%20illustration%2C%20cozy%20school%20clubroom%20with%20warm%20sunlight%2C%20friends%20chatting%2C%20soft%20relaxing%20atmosphere%2C%20clean%20minimal%20background%2C%20modern%20anime%20art%20style&width=800&height=500&seq=card-manga-05&orientation=landscape',
    tag: '专题合集',
    tagColor: 'bg-primary-100 text-primary-700',
    title: '夏日补习计划：最适合暑假看的漫画清单',
    desc: '暑假过半，来一份轻松愉快的夏日漫画清单，治愈你的假期时光。',
    time: '6天前',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mb-3">
            编辑精选
          </h2>
          <p className="text-sm text-foreground-500">皮皮漫画编辑团队倾心推荐</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cards.slice(0, 3).map((card, i) => (
            <div key={i} className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer">
              <div className="h-48 overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-medium mb-2 ${card.tagColor}`}>
                  {card.tag}
                </span>
                <h3 className="font-heading text-base text-foreground-900 mb-2">{card.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3">{card.desc}</p>
                <span className="text-xs text-foreground-400">{card.time}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5">
          {cards.slice(3).map((card, i) => (
            <div key={i} className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer flex flex-col sm:flex-row">
              <div className="sm:w-48 h-40 sm:h-auto overflow-hidden flex-shrink-0 bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 flex-1">
                <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-medium mb-2 ${card.tagColor}`}>
                  {card.tag}
                </span>
                <h3 className="font-heading text-base text-foreground-900 mb-2">{card.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3">{card.desc}</p>
                <span className="text-xs text-foreground-400">{card.time}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}